/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import OfferItemLayout from './OfferItemLayout';
import { MODAL_SCREENS } from '../constants';

const OfferListContainer = ({ date, data, showDepositOffer, setDetails }) => {
  const { t: translate } = useTranslation();

  const handleYieldDepositOnClick = (item) => {
    setDetails(item);
    showDepositOffer(MODAL_SCREENS.DEPOSIT);
  };

  return (
    <div className={`mt-3 container px-0 ${isMobile ? 'p-0' : ''}`}>
      {date && (
        <div className={`${isMobile ? 'py-2' : ''} row mx-0`}>
          <h6 className="text-center text-shadow text-f6 mb-0">
            {translate('yield_expirity_date_label').replace(
              '__DATE__',
              moment(date, 'YYYYMMDDh:mm:ss').format('DD MMMM YYYY')
            )}
          </h6>
        </div>
      )}
      {data &&
        data.map((item) => (
          <OfferItemLayout
            key={`${item?.id}`}
            item={item}
            onDepositClick={handleYieldDepositOnClick}
          />
        ))}
    </div>
  );
};

export default OfferListContainer;

OfferListContainer.propTypes = {
  date: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  showDepositOffer: PropTypes.func.isRequired,
  setDetails: PropTypes.func.isRequired,
};
